import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SignalCard = ({ signal, onExecuteTrade, onViewDetails }) => {
  const getSignalTypeColor = (type) => {
    switch (type?.toLowerCase()) {
      case 'buy':
        return 'text-success bg-success/10 border-success/20';
      case 'sell':
        return 'text-error bg-error/10 border-error/20';
      case 'hold':
        return 'text-warning bg-warning/10 border-warning/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getConfidenceColor = (confidence) => {
    if (confidence >= 80) return 'text-success';
    if (confidence >= 60) return 'text-warning';
    return 'text-error';
  };

  const getTimeUrgencyIcon = (urgency) => {
    switch (urgency) {
      case 'high':
        return 'AlertTriangle';
      case 'medium':
        return 'Clock';
      case 'low':
        return 'Timer';
      default:
        return 'Clock';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-standard">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
            <span className="text-sm font-semibold text-primary">
              {signal?.pair?.split('/')?.[0]?.slice(0, 2)}
            </span>
          </div>
          <div>
            <h3 className="font-semibold text-card-foreground">{signal?.pair}</h3>
            <p className="text-sm text-muted-foreground">{signal?.exchange}</p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <span className={`px-2 py-1 rounded-md text-xs font-medium border ${getSignalTypeColor(signal?.type)}`}>
            {signal?.type?.toUpperCase()}
          </span>
          <Icon 
            name={getTimeUrgencyIcon(signal?.urgency)} 
            size={16} 
            className={`${signal?.urgency === 'high' ? 'text-error' : signal?.urgency === 'medium' ? 'text-warning' : 'text-muted-foreground'}`}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Confidence</p>
          <p className={`text-sm font-semibold ${getConfidenceColor(signal?.confidence)}`}>
            {signal?.confidence}%
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Entry Price</p>
          <p className="text-sm font-semibold text-card-foreground">
            ${signal?.entryPrice?.toLocaleString()}
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Target Price</p>
          <p className="text-sm font-semibold text-success">
            ${signal?.targetPrice?.toLocaleString()}
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Stop Loss</p>
          <p className="text-sm font-semibold text-error">
            ${signal?.stopLoss?.toLocaleString()}
          </p>
        </div>
      </div>
      <div className="mb-4">
        <p className="text-xs text-muted-foreground mb-2">Analysis Summary</p>
        <p className="text-sm text-card-foreground line-clamp-2">
          {signal?.analysis}
        </p>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4 text-xs text-muted-foreground">
          <span>Generated: {signal?.generatedAt}</span>
          <span>Expires: {signal?.expiresAt}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onViewDetails(signal)}
            iconName="Eye"
            iconPosition="left"
          >
            Details
          </Button>
          <Button
            variant={signal?.type === 'buy' ? 'success' : signal?.type === 'sell' ? 'destructive' : 'secondary'}
            size="sm"
            onClick={() => onExecuteTrade(signal)}
            iconName={signal?.type === 'buy' ? 'TrendingUp' : signal?.type === 'sell' ? 'TrendingDown' : 'Minus'}
            iconPosition="left"
          >
            Execute
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SignalCard;